import { Component, OnInit, ViewEncapsulation, Input, ChangeDetectorRef, Output, EventEmitter, ViewContainerRef } from "@angular/core";
import { formatNumber } from '@angular/common';
import { SharedService } from '../shared'
import {
    EnumCAMTherapieName, EnumQuestionType, IQuestionnaireResponse, IQuestionnaireResponseData,
    getCategoryLabel, EnumSectionType, freeTextInputs, getFreeTextInput, LANGUAGE_ENUM
} from '../dateneingabe-frageboge/questionnaire.model';
import { CamProductList } from '../dateneingabe-frageboge/productList'
import { CamProductList_EN } from '../dateneingabe-frageboge/productList-en'
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { cloneDeep } from "lodash";
import { CaseSharePopupComponent } from './case-share-popup';
import { RezeptConfigPopupComponent } from "./rezept-config-popup";
import { PrescriptionPopupComponent } from "./prescription-popup";

declare var jsPanel: any;

@Component({
    selector: 'card-detail-popup',
    templateUrl: "./card-detail-popup.component.html",
    styleUrls: ["./card-detail-popup.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class CardDetailPopupComponent implements OnInit {
    @Input() pageName: 'RECORDS' | 'RECORDS_EN' | 'CARDS' | 'CARDS_EN' | 'SHARED' | 'SHARED_EN' | '' = '';
    @Input() cardDetail: IQuestionnaireResponseData = null;
    @Input() hideDownload: boolean = false;
    @Input() hideShare: boolean = false;
    @Input() sharePage: boolean = false;

    @Input() dataList: any[] = [];


    LANGUAGE_ENUM = LANGUAGE_ENUM;

    visiblePages: number[] = [];
    showSymptomeFreeText: boolean = false;
    showMedikamentFreeText: boolean = false;
    showNichtMedikamentFreeText: boolean = false;
    showNebenwirkungenFreeText: boolean = false;
    showActiveCAMFreeText: boolean = false;

    jsPanelPopup: any;
    jsPanelPopupRezept: any;

    get sharePanelWidth() {
        return Math.min(600, window.innerWidth - 60);
    }

    get sharePanelHeight() {
        return Math.min(150, window.innerHeight - 60);
    }

    get cardPanelWidth() {
        return Math.min(3500, window.innerWidth - 60);
    }

    get cardPanelHeight() {
        return Math.min(1000, window.innerHeight - 60);
    }

    get LANGUAGE() {
        return this.cardDetail?.RefId ? LANGUAGE_ENUM.EN : LANGUAGE_ENUM.DE;
    }

    constructor(private cd: ChangeDetectorRef,
        private vcr: ViewContainerRef,
        private sharedService: SharedService,
        private toastrService: ToastrService) {
    }

    ngOnInit(): void {
        this.setDisplayPages();
    }

    setDisplayPages() {
        let width = window.innerWidth;
        if (width < 1920) {
            if (this.visiblePages.length != 1) {
                this.visiblePages = [1];
            }
        } else {
            this.visiblePages = [1, 2];
        }

    }

    onResizeWindow(event) {
        this.setDisplayPages();

        if (this.jsPanelPopup) {
            this.jsPanelPopup.resize({
                width: () => { return this.cardPanelWidth; },
                height: () => { return this.cardPanelHeight; }
            }).reposition(); // reposition panel in order to maintain centered position
        }
        if (this.jsPanelPopupRezept) {
            this.jsPanelPopupRezept.resize({
                width: () => { return this.cardPanelWidth; },
                height: () => { return this.cardPanelHeight; }
            }).reposition(); // reposition panel in order to maintain centered position
        }
    }

    isActivePage(page) {
        return this.visiblePages.indexOf(page) >= 0;
    }

    fnDisplayPage(page) {
        if (!this.isActivePage(page)) {
            this.visiblePages = [page];
        }
    }

    get CurrentCaseIndex() {
        if (this.cardDetail) {
            let index = this.dataList.findIndex(a => a.Id == this.cardDetail.Id);
            return index;
        }
        return -1;
    }

    get isPrevCaseAllow() {
        if (this.CurrentCaseIndex >= 0) {
            if (this.CurrentCaseIndex == 0) {
                return false;
            } else {
                return true;
            }
        }
        return false;
    }

    get isNextCaseAllow() {
        if (this.CurrentCaseIndex >= 0) {
            if (this.CurrentCaseIndex >= this.dataList.length - 1) {
                return false;
            } else {
                return true;
            }
        }
        return false;
    }

    fnGoToPrevCase() {
        if (this.isPrevCaseAllow && this.CurrentCaseIndex >= 0) {
            this.fnResetAll();
            this.cardDetail = cloneDeep(this.dataList[this.CurrentCaseIndex - 1]);
        }
    }

    fnGoToNextCase() {
        if (this.isNextCaseAllow && this.CurrentCaseIndex >= 0) {
            this.fnResetAll();
            this.cardDetail = cloneDeep(this.dataList[this.CurrentCaseIndex + 1]);
        }
    }

    fnResetAll() {
        this.showSymptomeFreeText = false;
        this.showMedikamentFreeText = false;
        this.showNichtMedikamentFreeText = false;
        this.showNebenwirkungenFreeText = false;
        this.showActiveCAMFreeText = false;
        this.visiblePages = [];
        this.setDisplayPages();
    }


    fnDownloadCase() {
        var html = document.getElementById("card-detail-popup").outerHTML;
        this.sharedService.printHTMLData(html, {
            headCss: true,
            pageCss: `<style>@page {size: 1920px 1358px; margin: 0;}</style>`,
            extraCss: `<style>body {width: 100%; }.case-print-view-close.show-on-blank{display:flex;} .case-next-prev-buttons.hide-on-blank,.card-detail-header-right.hide-on-blank{display:none;}</style>`,
            title: `${this.LANGUAGE == LANGUAGE_ENUM.EN ? 'PEP case studies' : 'PEP Kasuistik'} ${this.cardDetail.Id}`
        });
    }

    get URL() {
        if (this.LANGUAGE == LANGUAGE_ENUM.EN) {
            return `${window.location.origin}/pep/en/case/doccheck/${this.cardDetail.UniqueId}`;
        } else {
            return `${window.location.origin}/pep/case/doccheck/${this.cardDetail.UniqueId}`;
        }
    }

    fnOpenEmail() {
        var email = '';
        var subject = '';
        var emailBody = '';
        if (this.LANGUAGE == LANGUAGE_ENUM.EN) {
            subject = `A PEP case study has been shared with you`;
            emailBody = `This link takes you to the 𝐏𝐄𝐏 𝐛𝐲 𝐂𝐨𝐩𝐞𝐢𝐚 – 𝐏𝐡𝐲𝐬𝐢𝐜𝐢𝐚𝐧𝐬 𝐄𝐱𝐩𝐞𝐫𝐢𝐞𝐧𝐜𝐞 𝐏𝐥𝐚𝐭𝐟𝐨𝐫𝐦, where you’ll find a case report from medical cannabis therapy:

            ${this.URL}

            To access PEP and view this case report in your web browser, you must log in via 𝐃𝐨𝐜𝐂𝐡𝐞𝐜𝐤 as a verified healthcare professional.

            Learn more at: copeia.de/pep/en

            Your Copeia Team
            `;
        } else {
            subject = `Eine PEP Kasuistik wurde mit Ihnen geteilt`;
            emailBody = `
Dieser Link leitet Sie zur 𝐏𝐄𝐏 𝐛𝐲 𝐂𝐨𝐩𝐞𝐢𝐚 𝐏𝐡𝐲𝐬𝐢𝐜𝐢𝐚𝐧 𝐄𝐱𝐩𝐞𝐫𝐢𝐞𝐧𝐜𝐞 𝐏𝐥𝐚𝐭𝐟𝐨𝐫𝐦. Hier finden Sie eine Kasuistik aus der medizinischen Therapie mit Cannabisarzneimitteln.


${this.URL}


Um PEP und diese Kasuistik in Ihrem Webbrowser zu öffnen, müssen Sie sich über einen DocCheck-Login als medizinisches Fachpersonal anmelden.

𝐇𝐚𝐛𝐞𝐧 𝐒𝐢𝐞 𝐚𝐮𝐜𝐡 𝐞𝐢𝐧𝐞𝐧 𝐬𝐩𝐚𝐧𝐧𝐞𝐧𝐝𝐞𝐧 𝐅𝐚𝐥𝐥? Teilen Sie Ihre Erfahrungen, und inspirieren Sie Kolleg:innen mit wissenswerten Therapieansätzen. Wissen teilen, Therapie verbessern.

Erfahren Sie mehr unter: copeia.de/pep

Ihr Copeia Team`;
        }

        var mailLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(emailBody)}`;
        //console.log(mailLink)
        document.location = mailLink;
    }

    fnShareCase() {
        this.cd.detectChanges();
        let component = this;
        const componentRef = this.vcr.createComponent(CaseSharePopupComponent);
        componentRef.instance.LANGUAGE = this.LANGUAGE;
        componentRef.instance.URL = this.URL;

        componentRef.instance.onButtonClick.subscribe((type) => {
            switch (type) {
                case 'EMAIL':
                    this.fnOpenEmail();
                    break;
                case 'COPY':
                    this.fnCopyUrl();
                    break;
            }
            this.jsPanelPopup.close();
        })

        const element = componentRef.location.nativeElement;
        this.jsPanelPopup = jsPanel.create({
            id: "jsPanelShare",
            theme: 'dark',
            panelSize: {
                width: () => { return component.sharePanelWidth; },
                height: () => { return component.sharePanelHeight; }
            },
            animateIn: 'jsPanelFadeIn',
            header: false,
            border: '1px solid #B4B4B4',
            borderRadius: '10px',
            addCloseControl: 1,
            css: {
                panel: 'jsPanelFixed share-panel'
            },
            onwindowresize: true,
            dragit: {
                disable: true
            },
            resizeit: {
                disable: true
            },
            onstatuschange: (panel, status) => {
            },
            onclosed: (panel, closedByUser) => {
                this.jsPanelPopup = undefined;
            },
            content: element,
            callback: function (panel) {
            }
        });
        this.jsPanelPopup = this.sharedService.setJsPanelProperty(this.jsPanelPopup);
    }

    fnCopyUrl() {
        this.copyMessage(this.URL);
        this.toastrService.success(this.LANGUAGE == LANGUAGE_ENUM.EN ? `URL Copied` : `URL kopiert`);
    }

    copyMessage(val: string) {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = val;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
    }

    isFreeTextData(obj: IQuestionnaireResponse) {
        if (obj.inputType == EnumQuestionType.DROPDOWN) {
            let value = obj.response["value"]
            if (typeof value == 'object') {
                var matched = freeTextInputs.filter(e => value.indexOf(e) !== -1);
                return matched.length > 0;
            } else {
                return freeTextInputs.indexOf(value) > -1;
            }
        }
        return false;
    }

    get createdMonth() {
        return this.getMonthFromDate(this.createdDate, 'END');
    }

    get createdDate() {
        return moment(this.cardDetail.Created);
    }

    getMonthFromDate(date: any, type: 'END' | 'START') {
        var mDate = moment(new Date(date));
        if (type == 'END') {
            return mDate.endOf("month");
        } else {
            return mDate.startOf("month");
        }
    }

    getCaseEntryDate() {
        return this.createdDate.format("DD.MM.YYYY");
    }

    getSubSections(sectionNumber, subSectionNumber) {
        let subSections = this.cardDetail.JsonData.filter(a => a.sectionNumber == sectionNumber && a.subSectionNumber == subSectionNumber);
        return subSections;
    }

    getQuestion(sectionNumber, subSectionNumber, questionNumber) {
        let subSections = this.getSubSections(sectionNumber, subSectionNumber);
        let question = subSections.find(a => a.questionNumber == questionNumber);
        return question;
    }

    getQuestionValue(sectionNumber, subSectionNumber, questionNumber) {
        let question = this.getQuestion(sectionNumber, subSectionNumber, questionNumber);
        if (question) {
            let freeText = question.response["freeText"];
            let value = question.response["value"];
            if (value && typeof value == 'object') {
                value = value.join(",");
            }
            return freeText || value;
        }
        return "";
    }

    getGenderImage() {
        let question = this.getQuestion(2, 1, 6);
        let value = "";
        if (question) {
            value = question.response["value"][0];
        }

        switch (value) {
            case 'Weiblich':
            case 'Female':
                return "/pep/images/icons/woman 60px.svg";
            case 'Divers':
            case 'Diverse':
                return "/pep/images/icons/diverse 60px.svg";
            default:
                return "/pep/images/icons/man 60px.svg";
        }
    }

    getAge() {
        let question = this.getQuestion(2, 1, 3);
        if (question) {
            let value = question.response["value"];
            if (value) {
                let year = this.beobOrDocumentDate.year();
                let diff = year - parseInt(value);
                return `${diff} ${this.LANGUAGE == LANGUAGE_ENUM.EN ? 'Years' : 'Jahre'}`;
            }
        }
        return "";
    }

    getBMI() {
        let weight = this.getQuestionValue(2, 1, 4);
        let height = this.getQuestionValue(2, 1, 5);
        if (weight && height) {
            weight = parseFloat(weight);
            height = parseFloat(height);

            let bmi = (weight / Math.pow((height / 100), 2));
            let bmiFixed = parseFloat(bmi.toFixed(1));
            if (this.LANGUAGE == LANGUAGE_ENUM.EN) {
                return bmiFixed;
            } else {
                return formatNumber(bmiFixed, "de");
            }
        }
        return "";
    }

    getCurrentCAMDate(type: 'MIN' | 'MAX') {
        let cams = this.getActiveCAMs();;
        let dates: any[] = [];
        if (cams) {
            cams.forEach(camObj => {
                if (camObj.startDate.value) {
                    dates.push(moment(new Date(camObj.startDate.value)));
                }
            })
        }
        if (dates.length) {
            let returnDate = null;
            if (type == 'MIN') {
                returnDate = moment.min(dates);
            } else {
                returnDate = moment.max(dates);
            }
            let date = moment(returnDate);
            if (date.isValid()) {
                return date;
            }
        }
        return null;
    }

    getAbgesetztCAMDate(type: 'MIN' | 'MAX') {
        let cams = this.getInActiveCAMs();
        let dates: any[] = [];
        if (cams) {
            cams.forEach(camObj => {
                if (camObj.startDate.value) {
                    dates.push(moment(new Date(camObj.startDate.value)));
                }
                if (camObj.endDate.value) {
                    dates.push(moment(new Date(camObj.endDate.value)));
                }
            })
        }
        if (dates.length) {
            let returnDate = null;
            if (type == 'MIN') {
                returnDate = moment.min(dates);
            } else {
                returnDate = moment.max(dates);
            }
            let date = moment(returnDate);
            if (date.isValid()) {
                return date;
            }
        }
        return null;
    }

    getBeobachtungszeitpunktDate() {
        let question = this.getQuestion(2, 1, 2);
        if (question) {
            let value = question.response["value"];
            if (value) {
                let date = moment(value);
                if (date.isValid()) {
                    return this.getMonthFromDate(date, 'END');
                }
            }
        }
        return null;
    }

    get isBeobDateInPast() {
        let beobDate = this.getBeobachtungszeitpunktDate();
        if (beobDate) {
            return this.createdDate.diff(beobDate, 'months') > 0;
        }
        return false;
    }

    get beobOrDocumentDate() {
        if (this.getBeobachtungszeitpunktDate()) {
            return this.getBeobachtungszeitpunktDate();
        } else {
            return this.createdMonth;
        }
    }

    getCAMTreatmentMonths() {
        let months = 0;
        let activeCams = this.getActiveCAMs();
        let inActiveCams = this.getInActiveCAMs();

        if (inActiveCams && inActiveCams.length) {
            let minDate = this.getAbgesetztCAMDate('MIN');
            let maxDate = this.getAbgesetztCAMDate('MAX');
            if (activeCams && activeCams.length) {
                months = minDate ? this.beobOrDocumentDate.diff(this.getMonthFromDate(minDate, 'START'), 'months') : 0;
            } else {
                months = (minDate && maxDate) ? this.getMonthFromDate(maxDate, 'END').diff(this.getMonthFromDate(minDate, 'START'), 'months') : 0;
            }
        } else {
            if (activeCams && activeCams.length) {
                let minDate = this.getCurrentCAMDate('MIN');
                months = minDate ? this.beobOrDocumentDate.diff(this.getMonthFromDate(minDate, 'START'), 'months') : 0;
            }
        }
        return `${months >= 0 ? months : -months} ${this.LANGUAGE == LANGUAGE_ENUM.EN ? 'Months' : 'Monate'}`;
    }

    getVersicherung() {
        let question = this.getQuestion(2, 1, 10);
        if (question) {
            let value = question.response["value"];
            if (this.LANGUAGE == LANGUAGE_ENUM.EN) {
                return value[0] == 'Statutory health insurance' ? 'GKV' : 'PKV';
            } else {
                return value[0] == 'Gesetzlich versichert' ? 'GKV' : 'PKV';
            }
        }
        return "";
    }

    getIndikationDate() {
        let question = this.getQuestion(3, 1, 3);
        if (question) {
            let value = question.response["value"];
            if (value) {
                let date = moment(value);
                if (date.isValid()) {
                    let dateMonth = this.getMonthFromDate(date, 'END');
                    let years = this.beobOrDocumentDate.diff(dateMonth, "years", true);
                    let yearsFixed = parseFloat(years.toFixed(1));
                    if (this.LANGUAGE == LANGUAGE_ENUM.EN) {
                        return yearsFixed + " Years";
                    } else {
                        return formatNumber(yearsFixed, "de") + " Jahren";
                    }
                }
            }
        }
        return "--"
    }

    getWeitereDiagnosen() {
        let question = this.getQuestion(3, 1, 5);
        if (question) {
            const stringOptions = question.response["extraOptions"]
                .map(opt => {
                    if (typeof opt === 'string') return opt;
                    if (typeof opt === 'object' && opt !== null) {
                        return opt.value;
                    }
                    return null;
                })
                .filter(opt => typeof opt === 'string');
            return stringOptions;
        }
        return [];
    }

    getSubstanzmissbrauch() {
        let question = this.getQuestion(2, 1, 15);
        if (question) {
            let value = question.response["value"];
            return value;
        }
        return [];
    }

    getGrundCamTherapie() {
        let question = this.getQuestion(3, 1, 4);
        if (question) {
            let value = cloneDeep(question.response["value"]);
            let freeText = question.response["freeText"];
            if (freeText) {
                value.push(freeText);
            }
            let freeInd = value.indexOf(getFreeTextInput(this.LANGUAGE));
            if (freeInd >= 0) {
                value.splice(freeInd, 1);
            }
            return value;
        }
        return [];
    }

    getSymptomes() {
        let subSections = this.getSubSections(4, 2);
        if (subSections.length) {
            let subSection = subSections[0];
            let symptomes = subSection.response;
            return symptomes as any[];
        }
        return [];
    }

    getSymptomesFreeText() {
        let symptomes = this.getSymptomes();
        return symptomes.find(a => a.freeText != null && a.freeText.length > 0) != null;
    }

    fnShowSymptomeFreeText(obj) {
        let subSections = this.getSubSections(4, 2);
        if (subSections.length) {
            let subSection = subSections[0];
            let symptomes = subSection.response as any[];
            if (obj) {
                symptomes.find(a => a.label == obj.label).showFreeText = !obj.showFreeText;
                this.showSymptomeFreeText = symptomes.filter(a => a.showFreeText != true).length <= 0;
            } else {
                this.showSymptomeFreeText = !this.showSymptomeFreeText;
                symptomes.forEach(a => {
                    a.showFreeText = this.showSymptomeFreeText;
                });
            }
        } else {
            this.showSymptomeFreeText = false;
        }
    }

    getPOSNEGSLIDER() {
        let question = this.getQuestion(9, 1, 1);
        if (question) {
            let value = question.response["value"];
            return {
                label: this.LANGUAGE == LANGUAGE_ENUM.EN ? "Impact on quality of life" : "Auswirkung auf die Lebensqualität",
                before: {
                    value: 0
                },
                after: {
                    value: value
                }
            };
        }
        return "";
    }

    getZusammenfassung() {
        let question = this.getQuestion(9, 1, 2);
        if (question) {
            let value = question.response["value"];
            return value;
        }
        return "";
    }

    getZusammenfassungBG() {
        switch (this.getZusammenfassung()) {
            case 'Stark verbessert':
            case 'Significantly improved':
                return "#155D1F";
            case 'Verbessert':
            case 'Improved':
                return "#1EAB50";
            case 'Gering verbessert':
            case 'Slightly improved':
                return "#09ED5B";
            case 'Gering verschlechtert':
            case 'Slightly worsened':
                return "#F77171";
            case 'Verschlechtert':
            case 'Worsened':
                return "#C83232";
            case 'Stark verschlechtert':
            case 'Significantly worsened':
                return "#FF0000";
            default:
                return "#6E6E6E";
        }
    }

    getMedikaments() {
        let subSections = this.getSubSections(5, 1);
        if (subSections.length) {
            let subSection = subSections[0];
            let medikaments = subSection.response;
            return medikaments as any[];
        }
        return [];
    }

    getMedikamentFreeText() {
        let medikaments = this.getMedikaments();
        return medikaments.find(a => a.freeText != null && a.freeText.length > 0) != null;
    }

    fnShowMedikamentFreeText(obj) {
        let subSections = this.getSubSections(5, 1);
        if (subSections.length) {
            let subSection = subSections[0];
            let medikaments = subSection.response as any[];
            if (obj) {
                medikaments.find(a => a.medikament.value == obj.medikament.value && a.freeText == obj.freeText).showFreeText = !obj.showFreeText;
                this.showMedikamentFreeText = medikaments.filter(a => a.showFreeText != true).length <= 0;
            } else {
                this.showMedikamentFreeText = !this.showMedikamentFreeText;
                medikaments.forEach(a => {
                    a.showFreeText = this.showMedikamentFreeText;
                });
            }
        } else {
            this.showMedikamentFreeText = false;
        }
    }

    getNichtMedikaments() {
        let subSections = this.getSubSections(6, 1);
        if (subSections.length) {
            let subSection = subSections[0];
            let medikaments = subSection.response;
            return medikaments as any[];
        }
        return [];
    }

    getNichtMedikamentFreeText() {
        let medikaments = this.getNichtMedikaments();
        return medikaments.find(a => a.freeText != null && a.freeText.length > 0) != null;
    }

    fnShowNichtMedikamentFreeText(obj) {
        let subSections = this.getSubSections(6, 1);
        if (subSections.length) {
            let subSection = subSections[0];
            let medikaments = subSection.response as any[];
            if (obj) {
                medikaments.find(a => a.medikament.value == obj.medikament.value && a.medikament.freeText == obj.medikament.freeText && a.freeText == obj.freeText).showFreeText = !obj.showFreeText;
                this.showNichtMedikamentFreeText = medikaments.filter(a => a.showFreeText != true).length <= 0;
            } else {
                this.showNichtMedikamentFreeText = !this.showNichtMedikamentFreeText;
                medikaments.forEach(a => {
                    a.showFreeText = this.showNichtMedikamentFreeText;
                });
            }
        } else {
            this.showNichtMedikamentFreeText = false;
        }
    }

    getNebenwirkungens() {
        let subSections = this.getSubSections(8, 2);
        if (subSections.length) {
            let subSection = subSections[0];
            let symptomes = subSection.response;
            return symptomes as any[];
        }
        return [];
    }

    getNebenwirkungenFreeText() {
        let symptomes = this.getNebenwirkungens();
        return symptomes.find(a => a.freeText != null && a.freeText.length > 0) != null;
    }

    fnShowNebenwirkungenFreeText(obj) {
        let subSections = this.getSubSections(8, 2);
        if (subSections.length) {
            let subSection = subSections[0];
            let symptomes = subSection.response as any[];
            if (obj) {
                symptomes.find(a => a.label == obj.label).showFreeText = !obj.showFreeText;
                this.showNebenwirkungenFreeText = symptomes.filter(a => a.showFreeText != true).length <= 0;
            } else {
                this.showNebenwirkungenFreeText = !this.showNebenwirkungenFreeText;
                symptomes.forEach(a => {
                    a.showFreeText = this.showNebenwirkungenFreeText;
                });
            }
        } else {
            this.showNebenwirkungenFreeText = false;
        }
    }

    getActiveCAMs() {
        let subSections = this.cardDetail.JsonData.filter(a => a.sectionNumber == 7 && a.subSectionType == EnumSectionType.CAMTHERAPIE && a.inputType == EnumCAMTherapieName.CAMTherapie);
        if (subSections.length) {
            let subSection = subSections[0];
            let cams = subSection.response as any[];
            return cams;
        }
        return [];
    }

    getActiveCAMFreeText() {
        let cams = this.getActiveCAMs();
        return cams.find(a => a.remarks.value != null && a.remarks.value.length > 0) != null;
    }

    fnShowActiveCAMFreeText(obj) {
        let subSections = this.cardDetail.JsonData.filter(a => a.sectionNumber == 7 && a.subSectionType == EnumSectionType.CAMTHERAPIE && a.inputType == EnumCAMTherapieName.CAMTherapie);
        if (subSections.length) {
            let subSection = subSections[0];
            let cams = subSection.response as any[];
            if (obj) {
                cams.find(a => this.getCamTherapieLabel(a) == this.getCamTherapieLabel(obj) && a.phaseDuration.value == obj.phaseDuration.value && a.dailyDosage.value == obj.dailyDosage.value && a.remarks.value == obj.remarks.value).showFreeText = !obj.showFreeText;
                this.showActiveCAMFreeText = cams.filter(a => a.showFreeText != true).length <= 0;
            } else {
                this.showActiveCAMFreeText = !this.showActiveCAMFreeText;
                cams.forEach(a => {
                    a.showFreeText = this.showActiveCAMFreeText;
                });
            }
        } else {
            this.showActiveCAMFreeText = false;
        }
    }

    getInActiveCAMs() {
        let subSections = this.cardDetail.JsonData.filter(a => a.sectionNumber == 7 && a.subSectionType == EnumSectionType.CAMTHERAPIE && a.inputType == EnumCAMTherapieName.CAMTherapieEnd);
        if (subSections.length) {
            let subSection = subSections[0];
            let cams = subSection.response as any[];
            return cams;
        }
        return [];
    }

    getCamTherapieIcon(option, active: boolean) {
        let value = option.category.value;
        var label = getCategoryLabel(value, this.LANGUAGE);
        switch (label) {
            case 'Blüten':
            case 'Flowers':
                return active ? "/pep/images/icons/Flower - Green.svg" : "/pep/images/icons/Flower - Red.svg";
            case 'Extrakte':
            case 'Extracts':
                return active ? "/pep/images/icons/Exract - Green.svg" : "/pep/images/icons/Exract - Red.svg";
            case 'Dronabinol':
                return active ? "/pep/images/icons/Dronabinol - Green.svg" : "/pep/images/icons/Dronabinol - Red.svg";
            case 'Sativex':
                return active ? "/pep/images/icons/Spray - Sativex - Green.svg" : "/pep/images/icons/Spray - Sativex - Red.svg";
            case 'Andere':
            case 'Other':
                return active ? "/pep/images/icons/Andere - Green.svg" : "/pep/images/icons/Andere - Red.svg";
            default:
                return active ? "/pep/images/icons/Kapsel - Green.svg" : "/pep/images/icons/Kapsel - Red.svg";
        }
    }

    getCamProductOptions(label) {
        if (this.LANGUAGE == LANGUAGE_ENUM.EN) {
            return CamProductList_EN.find(a => a.label == label)?.options || [];
        } else {
            return CamProductList.find(a => a.label == label)?.options || [];
        }
    }

    getCamTherapieLabel(option) {
        let freeText = option.product.freeText;
        if (freeText) {
            return freeText;
        } else {
            let category = option.category.value;
            let product = option.product.value;
            if (product) {
                var label = getCategoryLabel(category, this.LANGUAGE);
                let data = this.getCamProductOptions(label);
                let productItem = data.find(a => a.label == product);
                if (productItem && productItem.partner) {
                    return product;
                }
            }

            switch (category) {
                case 'Andere':
                case "Other":
                    return product;
                default:
                    return category;
            }
        }

    }

    getCamTherapieValue(option) {
        let freeText = option.product.freeText;
        if (freeText) {
            if (option.product['thc'] && option.product['cbd']) {
                return `${option.product['thc']}/${option.product['cbd']}`;
            } else {
                const match = freeText.match(/\(([^)]+)\)/);
                const value = match ? match[1] || "" : null;
                return value;
            }
        } else {
            let category = option.category.value;
            let product = option.product.value;
            if (product) {
                var label = getCategoryLabel(category, this.LANGUAGE);
                let data = this.getCamProductOptions(label);
                let productItem = data.find(a => a.label == product);
                if (productItem) {
                    //if (productItem.partner) {
                    //    return null;
                    //} else {
                    return productItem.thc_cbd;
                    //}
                }
            }
            return null;
        }
    }

    getCamTherapieStartDate(value) {
        let sdate = moment(value);
        if (sdate.isValid()) {
            let months = this.beobOrDocumentDate.diff(this.getMonthFromDate(sdate, 'START'), 'months');
            return months + " M";
        }
        return "--";
    }

    getCamTherapieMonth(camObj) {
        if (camObj.startDate.value && camObj.endDate.value) {
            let sdate = moment(camObj.startDate.value);
            let edate = moment(camObj.endDate.value);
            if (sdate.isValid() && edate.isValid()) {
                let months = this.getMonthFromDate(edate, 'END').diff(this.getMonthFromDate(sdate, 'START'), 'months');
                return months + " M";
            }

        }
        return "--";
    }


    getCamTherapieDate(value) {
        let date = moment(value);
        if (date.isValid()) {
            let month = date.format("MM.YYYY");
            return month;
        }
        return "--";
    }

    fnOpenRezeptPopup(camObj) {
        let component = this;
        let element = ``;
        let panelCss = "";
        let headerTitle = "";
        if (this.pageName == 'CARDS_EN' || this.pageName == 'SHARED_EN') {
            panelCss = "prescription-popup-container";
            headerTitle = "Country specific information";
            // Code for get html element from component
            const componentRef = this.vcr.createComponent(PrescriptionPopupComponent);
            componentRef.instance.LANGUAGE = LANGUAGE_ENUM.EN;
            componentRef.instance.camObj = camObj;

            element = componentRef.location.nativeElement;
        } else {
            headerTitle = "Rezeptvorlage";
            // Code for get html element from component
            const componentRef = this.vcr.createComponent(RezeptConfigPopupComponent);
            componentRef.instance.LANGUAGE = this.cardDetail.RefId ? LANGUAGE_ENUM.EN : LANGUAGE_ENUM.DE;
            componentRef.instance.camObj = camObj;

            element = componentRef.location.nativeElement;
        }

        this.jsPanelPopupRezept = jsPanel.create({
            id: "jsPanelRezept",
            theme: 'dark',
            panelSize: {
                width: () => { return component.cardPanelWidth; },
                height: () => { return component.cardPanelHeight; }
            },
            animateIn: 'jsPanelFadeIn',
            headerTitle: headerTitle,
            headerControls: 'closeonly',
            css: {
                content: panelCss,
                panel: 'jsPanelFixed'
            },
            onwindowresize: true,
            dragit: {
                disable: true
            },
            resizeit: {
                disable: true
            },
            onstatuschange: (panel, status) => {
            },
            onclosed: (panel, closedByUser) => {
                this.jsPanelPopupRezept = undefined;
            },
            content: element,
            callback: function (panel) {
            }
        });
        this.jsPanelPopupRezept = this.sharedService.setJsPanelProperty(this.jsPanelPopupRezept);
    }
}
